import { isLoading } from 'src/app/shared/utils/async';

import { useFcm } from '../../../../shared/fcm';
import type { LogoVariation } from '../../types';

export function useLogoVariation(): LogoVariation | undefined {
	const fcmState = useFcm();
	if (isLoading(fcmState)) return undefined;
	if (fcmState.values.showBlackHistoryLogo) return 'blackHistory';
	if (fcmState.values.showPrideLogo) return 'pride';
	if (fcmState.values.showClimateStrikeLogo) return 'climateStrike';
	return undefined;
}
